












































import Engine, { Player, PlayerEnum, PowerArea, Resource as ResourceEnum } from "@gaia-project/engine";
import { InfoTable } from "src/logic/table/types";
import { Component, Vue } from "vue-property-decorator";
import { MapMode, MapModeType } from "../data/actions";
import { orderedPlayers } from "../data/player";
import { mapModeTypeOptions } from "../data/stats";
import { infoTables } from "../logic/table/info-table";
import { rotate } from "../logic/utils";
import { UiMode } from "../store";
import TableCell from "./TableCell.vue";

@Component({
  components: {
    TableCell,
  },
})
export default class Table extends Vue {
  get engine(): Engine {
    return this.$store.state.data;
  }

  get orderedPlayers(): Player[] {
    const players = orderedPlayers(this.engine);
    const s = this.sessionPlayer;
    return s ? this.passedLast(rotate(players, s)) : players;
  }

  passedLast(players: Player[]): Player[] {
    const s = this.sessionPlayer;
    const e = this.engine;
    function passed(p: Player) {
      return (e.passedPlayers || []).includes(p.player);
    }

    if (s && !passed(s)) {
      return players.filter((p) => !passed(p)).concat(...players.filter((p) => passed(p)));
    }
    return players;
  }

  get sessionPlayer(): Player {
    const player = this.$store.state.player;
    if (player) {
      if (player.index !== undefined) {
        return this.engine.players[player.index];
      }
    }
  }

  get infoTables(): InfoTable[] {
    return infoTables(this.engine, this.orderedPlayers, this.uiMode, {
      convertTooltip: (resource, player) => this.convertTooltip(resource, player),
    });
  }

  get mapModeTypeOptions() {
    return mapModeTypeOptions;
  }

  selectedMapMode(player: PlayerEnum): MapModeType {
    return this.$store.getters.mapModes.find((m) => m.player === player)?.type ?? MapModeType.default;
  }

  toggleMapMode(player: PlayerEnum, mode: MapModeType) {
    this.$store.commit("toggleMapMode", { type: mode, player: player } as MapMode);
  }

  get uiMode(): UiMode {
    return this.$store.state.preferences.uiMode;
  }

  get compact(): boolean {
    return this.uiMode === UiMode.compactTable;
  }

  convertTooltip(resource: ResourceEnum | PowerArea, player: PlayerEnum): string | null {
    if (this.engine.currentPlayer == player) {
      return this.$store.state.context.fastConversionTooltips[resource];
    }
  }
}
